import { render, staticRenderFns } from "./ActivityShareCard.vue?vue&type=template&id=1e8a2328&scoped=true"
import script from "./ActivityShareCard.vue?vue&type=script&lang=ts"
export * from "./ActivityShareCard.vue?vue&type=script&lang=ts"
import style0 from "./ActivityShareCard.vue?vue&type=style&index=0&id=1e8a2328&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8a2328",
  null
  
)

export default component.exports